export enum filterEnum {
  TEMPERATURE = 'Temperature',
  FEELS_LIKE = 'Feels Like',
  DEWPOINT = 'Dewpoint',
  RH = 'Relative Humidity',
  PRECIP_AMOUNT = 'Precip Amount',
  PROBABILITY_OF_PRECIP = 'Probability of Precip',
  SURFACE_WIND = 'Surface Wind',
  WIND_GUST = 'Wind Gust',
  WIND_DIRECTION = 'Wind Direction',
  IRRADIANCE = 'Irradiance',
  PERC_OF_CLEAR_SKY = '% of Clear Sky',
  CLOUD_COVER = 'Cloud Cover',
}
